// ExamStudent.js
import { useRef, useEffect } from "react";

function ExamStudent() {
  const studentName = "Maryam";
  const studentId = useRef(Math.random().toString(36).substr(2, 9));
  const socket = useRef(new WebSocket("ws://192.168.40.1:5000")).current;
  const peerRef = useRef(null);
  const iceCandidatesQueue = useRef([]);

  useEffect(() => {
    peerRef.current = new RTCPeerConnection();

    socket.onmessage = async (event) => {
      const msg = JSON.parse(event.data);

      if (msg.answer) {
        // FIX: Only set remote description if the state is correct (expecting an answer)
        if (peerRef.current.signalingState === "have-local-offer") {
          console.log("Setting remote description (answer) in correct state.");
          await peerRef.current.setRemoteDescription(new RTCSessionDescription(msg.answer));
        } else {
          console.warn(`Ignoring answer received in unexpected signaling state: ${peerRef.current.signalingState}`);
        }
      }

      if (msg.candidate) {
        if (peerRef.current && peerRef.current.remoteDescription) {
           try {
            await peerRef.current.addIceCandidate(new RTCIceCandidate(msg.candidate));
           } catch (e) {
               console.error("Error adding ICE candidate on student side:", e);
           }
        } else {
          iceCandidatesQueue.current.push(msg.candidate);
        }
      }
    };

    socket.onopen = () => {
      console.log("Student connected to server");
      socket.send(JSON.stringify({ role: "student", name: studentName, studentId: studentId.current }));
    };

    peerRef.current.onicecandidate = (event) => {
      if (event.candidate) {
        socket.send(JSON.stringify({ candidate: event.candidate, to: "admin", from: studentId.current }));
      }
    };

    // Cleanup function
    return () => {
        socket.close();
        if (peerRef.current) {
            peerRef.current.close();
        }
    }
  }, [socket]);

  const startExam = async () => {
    // Request media access only when button is clicked
    const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
    stream.getTracks().forEach(track => peerRef.current.addTrack(track, stream));

    const offer = await peerRef.current.createOffer();
    await peerRef.current.setLocalDescription(offer);

    socket.send(JSON.stringify({ offer, studentId: studentId.current, studentName }));

    // Add queued ICE candidates
    iceCandidatesQueue.current.forEach(async (c) => {
      if (peerRef.current && peerRef.current.remoteDescription) {
        await peerRef.current.addIceCandidate(new RTCIceCandidate(c));
      }
    });
    iceCandidatesQueue.current = [];
  };

  return (
    <div>
      <h1>Student Exam</h1>
      <button onClick={startExam}>Start Exam</button>
    </div>
  );
}

export default ExamStudent;
